<template>
  <div class="flex flex-wrap mt-4">
    <div class="w-full mb-12 px-4">
      <card-record title="Tarea" resource="tareas" primaryKey="idtarea" :record="record" :columns="columns"
        @saveChanges="handleSave" :service="service" />
    </div>
  </div>
</template>
<script>
import CardRecord from "@/components/Cards/CardRecord.vue";
import TareaService from "@/services/tarea.service";
import { tarea } from "@/models/tarea";

export default {
  components: {
    CardRecord,
  },

  data() {
    return {
      record: {},
      columns: tarea,
      service: TareaService
    }
  },

  watch: {
    $route: {
      immediate: true,
      handler(/*to, from*/) {
        TareaService.get(this.$route.params.id).then((data) => {
          this.record = data.record;
        }).catch((response) => {
          console.log(response);
        });
      },
    },
  },

  methods: {
    handleSave(record) {
      this.record = record;
    }
  }
};
</script>
